import { Injectable } from '@angular/core';
import { IFieldOptions } from '../../framework/interfaces/IEntity';

@Injectable({
	providedIn: 'root'
})
export class InputValidationService {
	public patterns: any;
	constructor() { }

	testPattern(patternName, value, fieldOptions: IFieldOptions) {
		var _maxLengthCaption = null;
		var _minLengthCaption = null;
		var pattern = this.patterns[patternName];
		var regex = new RegExp(pattern.regex, pattern.flags);
		fieldOptions.placeholder = pattern.placeholder;
		if (!fieldOptions.maxLength && pattern.maxLength) fieldOptions.maxLength = pattern.maxLength;
		if (!fieldOptions.minLength && pattern.minLength) fieldOptions.minLength = pattern.minLength;
		if (pattern.ErrorConditions && pattern.ErrorConditions.maxLength) {
			_maxLengthCaption = pattern.ErrorConditions.maxLength.message
		}
		if (fieldOptions.maxLength != pattern.maxLength) _maxLengthCaption = "Cannot contain more than {{err.maxLength}} characters. Please reduce the number of characters in this field."

		let _patternCaption: string;
		var valid = regex.test(value) || value == "" || !value;
		if (!valid) {
			var errorPosition = -1,
				fieldValue = "";
			if (pattern.ErrorConditions) {
				if (pattern.ErrorConditions.pattern) {
					var patternErrorCondition = pattern.ErrorConditions.pattern,
						regexPattern = regex;
					if (patternErrorCondition.regex) regexPattern = new RegExp(patternErrorCondition.regex, pattern.flags);
					while (fieldValue.length < value.length && errorPosition == -1) {
						fieldValue += value[fieldValue.length];
						if (!regexPattern.test(fieldValue)) errorPosition = fieldValue.length;
					}
					_patternCaption = patternErrorCondition.message.replace("{{err.position}}", errorPosition);
				}
				if (errorPosition == -1 && pattern.ErrorConditions.format) {
					var formatErrorCondition = pattern.ErrorConditions.format,
						regexPattern = regex;
					if (formatErrorCondition.regex) regexPattern = new RegExp(formatErrorCondition.regex, pattern.flags);
					if (!regexPattern.test(value)) _patternCaption = formatErrorCondition.message;
				}
			}
			else {
				while (fieldValue.length < value.length && errorPosition == -1) {
					fieldValue += value[fieldValue.length];
					if (!regex.test(fieldValue)) errorPosition = fieldValue.length;
				}
				_patternCaption = pattern.caption.replace("{{err.position}}", errorPosition)
			}
		};

		if (fieldOptions.maxLength) {
			if (!_maxLengthCaption) _maxLengthCaption = "Cannot contain more than {{err.maxLength}} characters. Please reduce the number of characters in this field."
			_maxLengthCaption = _maxLengthCaption.replace("{{err.maxLength}}", fieldOptions.maxLength);

			var maxLengthValid = this.testMaxLengthErrors(fieldOptions, value);
			if (!maxLengthValid) {
				valid = false;
				if (_patternCaption)
					_patternCaption += "\n" + _maxLengthCaption;
				else
					_patternCaption = _maxLengthCaption;
			}
		}
		if (fieldOptions.minLength) {
			if (!_minLengthCaption) _minLengthCaption = "Cannot contain less than {{err.minLength}} characters. Please increase the number of characters in this field."
			_minLengthCaption = _minLengthCaption.replace("{{err.minLength}}", fieldOptions.minLength);

			var minLengthValid = this.testMinLengthErrors(fieldOptions, value);
			if (!minLengthValid) {
				valid = false;
				if (_patternCaption)
					_patternCaption += "\n" + _minLengthCaption;
				else
					_patternCaption = _minLengthCaption;
			}
		}
		if (_patternCaption) _patternCaption = _patternCaption.replace(/{{err.label}}/g, fieldOptions.name ? fieldOptions.name : "The field")
		return { valid: valid, msg: _patternCaption };
	}
	testMaxLengthErrors(fieldOptions, val) {
		//var val:string = scope.input.val() ? scope.input.val() : ctrl.$modelValue;
		if (fieldOptions.maxLength && val) return (val.length <= fieldOptions.maxLength);
		return true;
	}
	testMinLengthErrors(fieldOptions, val) {
		//var val:string = scope.input.val() ? scope.input.val() : ctrl.$modelValue;
		if (fieldOptions.minLength && val) return (val.length >= fieldOptions.minLength);
		return true;
	}
}
